(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gb-school-interest"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const requested = params.get('interest');
    const select = document.querySelector('#GbSchoolInterest-product-interest, #GbSchoolInterest-interest');
    if (requested && select && Array.from(select.options).some((option) => option.value === requested)) {
      select.value = requested;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const sessionId = params.get('session');
    const source = document.querySelector('[data-gb-school-sessions]');
    const target = document.querySelector('#GbSchoolInterest [data-gb-interest-session]');
    if (!sessionId || !source || !target) return;
    try {
      const session = JSON.parse(source.textContent).find((item) => item.mode === 'enquiry' && item.id === sessionId && item.status !== 'cancelled');
      if (session) {
        target.value = `${session.title} — ${session.days || session.first_date}`;
        const label = document.querySelector('#GbSchoolInterest [data-gb-interest-session-label]');
        if (label) { label.textContent = `Consulta sobre: ${target.value}. La consulta no reserva una plaza.`; label.hidden = false; }
      }
    } catch (_) { /* Invalid calendar data never populates the form. */ }
  });
  } catch(e) { console.error(e); }
})();

})();
